import React from "react";
import Button from "@mui/material/Button";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Checkbox from "@mui/material/Checkbox";
import Paper from "@mui/material/Paper";
import useAuth from "../../../hooks/useAuth";
import SelectAllContext from "./SelectAllContext";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const styles = {
  selectAllBox: {
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    borderBottom: "1px solid #e0e0e0",
    fontWeight: 500,
    zIndex: 10,
    padding: "8px 16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  selectAllBoxDisabled: {
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    borderBottom: "1px solid #e0e0e0",
    fontWeight: 500,
    zIndex: 10,
    padding: "8px 16px",
    cursor: "not-allowed",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    opacity: 0.5,
  },
  disabledMessage: {
    fontSize: "11px",
    color: "#888",
    fontStyle: "italic",
    fontWeight: 400,
  },
  buttonContainer: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  footerAction: {
    borderTop: "1px solid #e0e0e0",
    display: "flex",
    justifyContent: "center",
    padding: "8px 16px",
  },
};

const CustomPaperComponent = React.forwardRef(function CustomPaperComponent(props, ref) {
  const { children, ...paperProps } = props;
  const {
    multiple,
    handleSelectAll,
    getAllFilteredSelected,
    filteredOptionsRef,
    showAllProjects,
    toggleShowAllProjects,
    hasFieldValues,
    selectAllDisabled,
    viewAllLabel,
    showManagedSearchAction,
    managedSearchLabel,
    handleManagedSearchClick,
  } = React.useContext(SelectAllContext);
  const { user } = useAuth();
  const { settings } = user.company;
  const managedSearchButtonLabel =
    managedSearchLabel || `Search disabled ${(settings.filter_field3 || "projects").toLowerCase()}`;

  const showSelectAll =
    multiple && filteredOptionsRef?.current && filteredOptionsRef.current.length > 0;

  return (
    <Paper ref={ref} {...paperProps}>
      {showSelectAll && (
        <div
          style={selectAllDisabled ? styles.selectAllBoxDisabled : styles.selectAllBox}
          onMouseDown={(e) => e.preventDefault()}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: selectAllDisabled ? "not-allowed" : "pointer",
            }}
            onClick={selectAllDisabled ? undefined : handleSelectAll}
          >
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={getAllFilteredSelected()}
              disabled={selectAllDisabled}
            />
            Select All
            {selectAllDisabled && (
              <span style={styles.disabledMessage}>&nbsp;— temporarily disabled</span>
            )}
          </div>
          {hasFieldValues && !selectAllDisabled && (
            <div style={styles.buttonContainer}>
              <Button
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleShowAllProjects();
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                {showAllProjects
                  ? "Show Selected Only"
                  : `View All ${viewAllLabel || settings.filter_field3}`}
              </Button>
            </div>
          )}
        </div>
      )}
      {children}
      {showManagedSearchAction && (
        <div style={styles.footerAction} onMouseDown={(e) => e.preventDefault()}>
          <Button
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleManagedSearchClick();
            }}
          >
            {managedSearchButtonLabel}
          </Button>
        </div>
      )}
    </Paper>
  );
});

export default CustomPaperComponent;
